export function handleMegaNavMoreLinkClick(e) {
  e.preventDefault();
  this.parentElement.parentElement.className += "show-all";
  return false;
};

export function handleMegaNavCloseLinkClick(e) {
  e.preventDefault();
  evite.hide(findAncestor(e.target, 'mega-nav-wrapper'));
  return false;
};

export function findAncestor (element, className) {
    while ((element = element.parentElement) && !element.classList.contains(className));
    return element;
};



// WEBPACK FOOTER //
// ./assets/es6/nav/navigation.es6